import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Select from "react-select";
import Footer from './Footer.js';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Add_Employee = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [formData, setFormData] = useState({
    emp_code: '',
    fname: '',
    mname: '',
    lname: '',
    comp_name: '',
    doj: '',
    dob: '',
    gender: '',
    mail_id: '',
    report_mngr: '',
    function_mngr: '',
    ou_name: '',
    dept_name: '',
    location_name: '',
    designation_name: '',
    grade: '',
    region: '',
    country: 'India',
    city: '',
    position: '',
    cost_center: '',
    pay_group: '',
    mobile: '',
    bank_name: '',
    bank_acnum: '',
    ifsc_code: '',
  });

  const departmentOptions = departments.map((dept) => ({
    value: dept.dept_name,
    label: dept.dept_name,
  }));

  const locationOptions = locations.map((location) => ({
    value: location.location_name,
    label: location.location_name,
  }));

  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);

    setFormData((prev) => ({
      ...prev,
      location_name: selectedOption ? selectedOption.value : "",
    }));
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}departments`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Departments data:", result); // Debugging log

        if (Array.isArray(result)) {
          setDepartments(result);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError('Failed to load departments.');
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  useEffect(() => {
    const fetchLocations = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}locations`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Locations data:", result); // Debugging log

        if (Array.isArray(result)) {
          setLocations(result);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError('Failed to load locations.');
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;
      const response = await fetch(`${API_BASE_URL}postemployee`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();

      if (result.status) {
        toast.success('Employee Successfully Added');
        navigate('/manage_employee');

      } else {
        toast.error(result.error || "An Error Occured while adding employee");
      }


    } catch (err) {
      console.error('Request error ', err);
    } finally {
      setIsSubmitting(false);
    }


  };

  const handleBackClick = () => {
    navigate('/manage_employee');
  };

  return (
    <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
      <div className="wrapper">
        <Header />
        <Sidebar />

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Add Employee Form</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                    <li className="breadcrumb-item"><a href="/manage_employee">Employee Details</a></li>
                    <li className="breadcrumb-item active">Add Employee Form</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="col-lg-12">
            <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
              <div className="box box-info">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="box-body">
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="fname">First Name<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="fname"
                            id="fname"
                            value={formData.fname}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter First Name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="lname">Last Name<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="lname"
                            id="lname"
                            value={formData.lname}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Last Name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="mname">Middle Name</label>
                          <input
                            type="text"
                            name="mname"
                            id="mname"
                            value={formData.mname}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Middle Name"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="comp_name">Complete Name <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="comp_name"
                            id="comp_name"
                            value={formData.comp_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Complete Name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="doj">
                            Date of Joining <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            name="doj"
                            id="doj"
                            value={formData.doj}
                            onChange={handleChange}
                            className="form-control input-font"
                            required
                          />
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="dob">
                            Date of Birth <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            name="dob"
                            id="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            className="form-control input-font"
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="gender">
                            Gender <span className="text-danger">*</span>
                          </label>

                          <select
                            name="gender"
                            id="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            className="form-control input-font"
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                          </select>
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="mail_id">Email<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="email"
                            name="mail_id"
                            id="mail_id"
                            value={formData.mail_id}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Email"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="mobile">Mobile<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="number"
                            name="mobile"
                            id="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Mobile"
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="emp_code">BM ID<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="number"
                            name="emp_code"
                            id="emp_code"
                            value={formData.emp_code}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Emp Code"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="dept_name">
                            Dept <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select

                            options={departmentOptions}
                            placeholder="Search Department..."
                            value={
                              departmentOptions.find(
                                (option) => option.value === formData.dept_name
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                dept_name: selectedOption ? selectedOption.value : "",
                              }))
                            }
                            isSearchable
                            classNamePrefix="react-select"
                          />

                          {/* Hidden input for HTML validation */}
                          <input
                            type="hidden"
                            name="dept_name"

                            value={formData.dept_name}
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="designation_name">Designation<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="designation_name"
                            id="designation_name"
                            value={formData.designation_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Designation Name"
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="location_name">
                            Location <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            name="location_name"
                            options={locationOptions}
                            value={selectedLocation}
                            onChange={handleLocationChange}
                            placeholder="Select Location"
                            isSearchable
                            isClearable
                            classNamePrefix="react-select"
                          />

                          <input
                            type="hidden"
                            name="location_name"
                            value={formData.location_name}
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="grade">Band<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="grade"
                            id="grade"
                            value={formData.grade}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter grade name"
                            required
                          />
                        </div>
                        <div className="col-md-4 form-group">
                          <label htmlFor="report_mngr">Reportint Manager BM Id<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="report_mngr"
                            id="report_mngr"
                            value={formData.report_mngr}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter report manager"
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="function_mngr">Functional Manager BM Id</label>
                          <input
                            type="text"
                            name="function_mngr"
                            id="function_mngr"
                            value={formData.function_mngr}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter function manager"

                          />
                        </div>




                        <div className="col-md-4 form-group">
                          <label htmlFor="ou_name">
                            OU Name <span className="text-danger">*</span>
                          </label>

                          <select
                            name="ou_name"
                            id="ou_name"
                            value={formData.ou_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            required
                          >
                            <option value="">Select OU Name</option>
                            <option value="Vijaya Diagnostic Centre Limited">VDC</option>
                            <option value="PH Diagnostic Centre Pvt Ltd">PH</option>
                            <option value="Medinova Millennium MRI Services LLP">Medinova</option>
                          </select>
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="region">
                            Region <span className="text-danger">*</span>
                          </label>

                          <select
                            name="region"
                            id="region"
                            value={formData.region}
                            onChange={handleChange}
                            className="form-control input-font"
                            required
                          >
                            <option value="">Select Region</option>
                            <option value="South">South</option>
                            <option value="North">North</option>
                          </select>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="country">Country</label>
                          <input
                            type="text"
                            name="country"
                            id="country"
                            value={formData.country}
                            onChange={handleChange}
                            className="form-control input-font"
                            readOnly
                          />
                        </div>


                        <div className="col-md-4 form-group">
                          <label htmlFor="city">
                            City <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="city"
                            id="city"
                            value={formData.city}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter City"
                            required
                          />
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="position">Position</label>
                          <input
                            type="text"
                            name="position"
                            id="position"
                            value={formData.position}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Position"
                          />
                        </div>

                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="cost_center">Cost Center</label>
                          <input
                            type="text"
                            name="cost_center"
                            id="cost_center"
                            value={formData.cost_center}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Cost Center"
                          />
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="pay_group">Pay Group</label>
                          <input
                            type="text"
                            name="pay_group"
                            id="pay_group"
                            value={formData.pay_group}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="Enter Pay Group"
                          />
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="bank_name">Bank<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="bank_name"
                            id="bank_name"
                            value={formData.bank_name}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="bank name"
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 form-group">
                          <label htmlFor="bank_acnum">Bank Acc No<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="bank_acnum"
                            id="bank_acnum"
                            value={formData.bank_acnum}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="bank_acnum"
                            required
                          />
                        </div>

                        <div className="col-md-4 form-group">
                          <label htmlFor="ifsc_code">IFSC Code<span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            name="ifsc_code"
                            id="ifsc_code"
                            value={formData.ifsc_code}
                            onChange={handleChange}
                            className="form-control input-font"
                            placeholder="ifsc_code"
                            required
                          />
                        </div>
                        <div />
                      </div>
                    </div>

                    <div className="box-footer text-center">
                      <div className="row justify-content-center">
                        <div className="col-auto">
                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={!formData.emp_code || isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="btn btn-secondary" onClick={handleBackClick}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Footer />

        <aside className="control-sidebar control-sidebar-dark" />
      </div>

      <ToastContainer />
    </div>
  );
};

export default Add_Employee;
